var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSiteMap = function SvgSiteMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.999 22.631-5-2.5V1.368l5 2.5v18.763Zm-6-2.5-5 2.5V3.868l5-2.5v18.763Zm-6 2.5-5-2.5V1.368l5 2.5v18.763Zm-6-2.5L1 22.631V3.868l4.999-2.5v18.763ZM19.116.307 18.999.25l-.5-.25-.5.249V.25L12.499 3 7.159.33l-.16-.08-.5-.25L0 3.25v21L6.499 21l5.392 2.696.108.054.5.25.5-.25.236-.119L18.499 21l6.5 3.25v-21L19.116.307Z"
  })));
};
export default SvgSiteMap;